import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatPrice } from "../../lib/api";
import { Image, ShoppingCart, Bell, Users, Plus } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then(({ data }) => setStats(data)); }, []);

  const cards = [
    { label: "Картини", value: stats?.products, icon: Image },
    { label: "Поръчки", value: stats?.orders, icon: ShoppingCart },
    { label: "Нови поръчки", value: stats?.new_orders, icon: Bell },
    { label: "Абонати", value: stats?.subscribers, icon: Users },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="flex items-center justify-between mb-8">
        <h1 className="font-serif text-3xl text-navy">Табло</h1>
        <Link to="/admin/products/new" className="btn-gold px-5 py-2.5 rounded-sm flex items-center gap-2 text-sm"><Plus size={16} /> Нова картина</Link>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 mb-8">
        {cards.map((c) => (
          <div key={c.label} className="bg-white border border-stone p-6" data-testid={`stat-${c.label}`}>
            <c.icon size={22} className="text-gold mb-3" />
            <p className="font-serif text-3xl text-navy">{c.value ?? "—"}</p>
            <p className="text-sm text-charcoal/55 mt-1">{c.label}</p>
          </div>
        ))}
      </div>
      <div className="bg-white border border-stone p-6">
        <p className="text-charcoal/55 text-sm">Общ оборот (всички поръчки)</p>
        <p className="font-serif text-3xl text-navy mt-1">{stats ? formatPrice(stats.revenue) : "—"}</p>
      </div>
      <div className="grid md:grid-cols-3 gap-5 mt-8">
        <Link to="/admin/products" className="bg-navy text-ivory p-6 hover:bg-navy/90"><Image size={22} className="text-gold mb-3" /><p className="font-serif text-xl">Управление на картини</p><p className="text-ivory/60 text-sm mt-1">Добавяне, редакция, импорт</p></Link>
        <Link to="/admin/orders" className="bg-navy text-ivory p-6 hover:bg-navy/90"><ShoppingCart size={22} className="text-gold mb-3" /><p className="font-serif text-xl">Поръчки</p><p className="text-ivory/60 text-sm mt-1">Проследяване на статуси</p></Link>
        <Link to="/admin/settings" className="bg-navy text-ivory p-6 hover:bg-navy/90"><Users size={22} className="text-gold mb-3" /><p className="font-serif text-xl">SEO и интеграции</p><p className="text-ivory/60 text-sm mt-1">Анализи, соц. мрежи</p></Link>
      </div>
    </div>
  );
}
